// extracted by mini-css-extract-plugin
export var actions = "_su-4";
export var item = "_su-1";
export var price = "_su-3";
export var quantity = "_su-2";
export var table = "_su-0";